var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI9Form(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.017,
    height: 29.373,
    viewBox: "0 0 26.017 29.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28322",
    "data-name": "Group 28322",
    transform: "translate(-508.239 -281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27741",
    "data-name": "Group 27741",
    transform: "translate(2510.395 -1194.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8925",
    "data-name": "Path 8925",
    d: "M-1977.785,1486.094h-.7v-3.4a.49.49,0,0,0-.006-.064.566.566,0,0,0-.143-.376l-5.661-6.466a.571.571,0,0,0-.115-.1l-.042-.026a.6.6,0,0,0-.114-.048l-.031-.01a.588.588,0,0,0-.132-.016h-13.922a1.153,1.153,0,0,0-1.152,1.152v9.357h-.7a1.646,1.646,0,0,0-1.651,1.642h0v8.566a1.646,1.646,0,0,0,1.646,1.646h.7v5.86a1.153,1.153,0,0,0,1.156,1.148h19.011a1.153,1.153,0,0,0,1.151-1.148v-5.864h.7a1.647,1.647,0,0,0,1.651-1.642h0v-8.566A1.646,1.646,0,0,0-1977.785,1486.094Zm-20.868-9.357h13.342v5.893a.577.577,0,0,0,.575.576h5.088v2.889h-19.005Zm19.011,26.758h-19.011v-5.548h19.011Z",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27739",
    "data-name": "Group 27739",
    transform: "translate(-1995.623 1488.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8926",
    "data-name": "Path 8926",
    d: "M-1905.487,1671.768v-8.435h1.817v8.435Z",
    transform: "translate(1905.487 -1663.299)",
    fill: "#fff4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M-1856.077,1732.55v-1.617h3.388v1.617Z",
    transform: "translate(1859.416 -1726.33)",
    fill: "#fff4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M-1798.5,1669.342l1.67-.173a1.1,1.1,0,0,0,.319.708.985.985,0,0,0,.681.23,1.134,1.134,0,0,0,.908-.46,3.731,3.731,0,0,0,.479-1.91,2.118,2.118,0,0,1-1.627.708,2.506,2.506,0,0,1-1.832-.768,2.7,2.7,0,0,1-.77-2,2.744,2.744,0,0,1,.813-2.068,2.86,2.86,0,0,1,2.072-.785,2.864,2.864,0,0,1,2.246.992,4.89,4.89,0,0,1,.878,3.265,4.953,4.953,0,0,1-.915,3.337,3.043,3.043,0,0,1-2.382,1.024,2.63,2.63,0,0,1-1.706-.526A2.489,2.489,0,0,1-1798.5,1669.342Zm3.9-3.533a1.767,1.767,0,0,0-.384-1.214,1.158,1.158,0,0,0-.887-.431,1.021,1.021,0,0,0-.795.354,1.722,1.722,0,0,0-.316,1.159,1.759,1.759,0,0,0,.344,1.2,1.107,1.107,0,0,0,.859.383,1.1,1.1,0,0,0,.838-.368A1.541,1.541,0,0,0-1794.6,1665.809Z",
    transform: "translate(1805.893 -1662.823)",
    fill: "#fff4e9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI9Form);
export default __webpack_public_path__ + "static/media/i9_form.1758138e14688fe9349f3f3851f34535.svg";
export { ForwardRef as ReactComponent };